import { CORE_INPUT_TEXT_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../../fabrics/createDisplayName";

export const createDisplayNameForCoreInputTextElement = createDisplayName(
    CORE_INPUT_TEXT_DISPLAY_NAME,
);
